import React from 'react';
import SectionsNavigation from './SectionsNavigation';
import PlanSectionEditor from './PlanSectionEditor';
import AISuggestionPanel from './AISuggestionPanel';
import { PREDEFINED_SECTIONS } from '../../constants/plansConstants';

const PlanEditor = ({ 
  activePlan,
  activeSection,
  fieldValue,
  saving,
  aiLoading,
  ai,
  aiError,
  guide,
  allSectionsComplete,
  usageLimits,
  onSectionChange,
  onTextChange,
  onSave,
  onSuggest,
  onGenerateActionPlan,
  onViewActionPlan,
  onShowGuide,
  onCloseGuide,
  onCloseAi
}) => {
  if (!activePlan) {
    return <p>Selecciona o crea un plan.</p>;
  }

  const getUsageStats = () => {
    if (!usageLimits) return null;
    const actionPlansRemaining = usageLimits.action_plans?.remaining || 0;
    return {
      actionPlansRemaining
    };
  };

  const stats = getUsageStats();

  return (
    <div>
      <div className="plan-header">
        <div className="plan-header-left">
          <h1>{activePlan.title}</h1>
          {stats && stats.actionPlansRemaining === 0 && !activePlan.action_plan_md && (
            <span className="usage-badge limit-reached" title="Límite diario de generaciones alcanzado">
              ⏰ Sin generaciones disponibles hoy
            </span>
          )}
        </div>
        {activePlan.action_plan_md && (
          <button className="view-action-plan-btn" onClick={onViewActionPlan}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>
            </svg>
            Ver plan de acción
          </button>
        )}
      </div>
      <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
        <SectionsNavigation
          activeSection={activeSection}
          activePlan={activePlan}
          aiLoading={aiLoading}
          allSectionsComplete={allSectionsComplete}
          usageLimits={usageLimits}
          onSectionChange={onSectionChange}
          onGenerateActionPlan={onGenerateActionPlan}
        />
        
        <div style={{ flex: 1, minWidth: 0 }}>
          <PlanSectionEditor
            activeSection={activeSection}
            activePlan={activePlan}
            fieldValue={fieldValue}
            saving={saving}
            aiLoading={aiLoading}
            guide={guide}
            usageLimits={usageLimits}
            onTextChange={onTextChange}
            onSave={onSave}
            onSuggest={onSuggest}
            onShowGuide={onShowGuide}
            onCloseGuide={onCloseGuide}
          />
          
          <AISuggestionPanel
            aiData={ai}
            aiError={aiError}
            isPredefined={PREDEFINED_SECTIONS.has(activeSection)}
            predefinedLabel="Recomendaciones BMC"
            onClose={onCloseAi}
          />
        </div>
      </div>
    </div>
  );
};

export default PlanEditor;
